import { SupplierOrderLine } from 'src/app/board/activity/activity-shared/activity-suppliers-orders/stores/activity-purchases-new-order/activity-purchases-new-order.state';
import {
    AchatDevisCdeModelDto,
    ArticleModelDto,
    CriteresArticlesFournisseurModelInput,
    FournisseurModelDto,
    ReglementModelDto
} from 'src/graphql/generated-types';

const actionPrefix = '[ActivityPurchasesNewOrder]';

export class ActivityPurchasesNewOrderLoadRelatedListAction {
    static type = actionPrefix + 'Load related lists';

    constructor(public activityId: number) {
    }
}

export class ActivityPurchasesNewOrderSetSupplierAndInitAction {
    static type = actionPrefix + 'Set Supplier And Init';

    constructor(public supplier: FournisseurModelDto) {
    }
}

export class ActivityPurchasesNewOrderResetSupplierAction {
    static type = actionPrefix + 'Reset Supplier';

}

export class ActivityPurchasesNewOrderAddOrderLineAction {
    static type = actionPrefix + 'Add Order Line';

    constructor(public article: ArticleModelDto, public quantity: number) {
    }
}

export class ActivityPurchasesNewOrderEditOrderLineAction {
    static type = actionPrefix + 'Edit Order Line';

    constructor(public orderLine: SupplierOrderLine, public orderLineIndex: number) {
    }
}

export class ActivityPurchasesNewOrderRemoveOrderLineAction {
    static type = actionPrefix + 'Remove Order Line';

    constructor(public orderLineIndex: number) {
    }
}

export class ActivityPurchasesNewOrderAddAutomaticArticlesOrderLinesAction {
    static type = actionPrefix + 'Add Automatic Articles Order Lines';

    constructor(public criterias: CriteresArticlesFournisseurModelInput) {
    }
}

export class ActivityPurchasesNewOrderUpdateOrderAction {
    static type = actionPrefix + 'Update Order';

    constructor(public order: AchatDevisCdeModelDto) {
    }
}

export class ActivityPurchasesNewOrderAddDepositAction {
    static type = actionPrefix + 'Add Deposit';

    constructor(public payment: ReglementModelDto) {
    }
}

export class ActivityPurchasesNewOrderRemoveDepositAction {
    static type = actionPrefix + 'Remove Deposit';

    constructor(public index: number) {
    }
}

export class ActivityPurchasesNewOrderSaveAction {
    static type = actionPrefix + 'Save Order';

    constructor(public amounts: {
        shippingFees: number,
        supplierCommission: number,
        globalSubvention: number,
    }) {
    }
}
